import { useSuspenseQuery } from "@tanstack/react-query";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { useCustomerAppConfig } from "@wayflyer/undercarriage";

import { NEW_BANKING_ACCOUNTS_PAGE_FLAG } from "../../components/constants";
import { groupedBankingSourcesQueryOptions } from "../../queries/bank-connect/queries";

import { BankingAccountsPage } from "./banking-accounts";
import { BankingNextPage } from "./banking-next";
import { shouldShowNewAccountsPage } from "./should-show-new-accounts-page";

export const BankingPage = () => {
  const newAccountsPageEnabled = useFeatureFlagEnabled(NEW_BANKING_ACCOUNTS_PAGE_FLAG) === true;

  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { data: groupedSources } = useSuspenseQuery(groupedBankingSourcesQueryOptions(customerDomain));

  return shouldShowNewAccountsPage(newAccountsPageEnabled, groupedSources) ? (
    <BankingAccountsPage />
  ) : (
    <BankingNextPage />
  );
};
